// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"76521341","557":"6c8c6d7d","779":"8a5394c0","787":"5128b469"}[chunkId] + ".chunk.js";
};